import { Icon } from "semantic-ui-react";
import React, { useState } from "react";

const DotsWithArrowsPagination = ({
  totalItems,
  itemsPerPage,
  onPageChange,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      const newPage = currentPage - 1;
      setCurrentPage(newPage);
      onPageChange(newPage);
    }
  };

  const goToNextPage = () => {
    if (currentPage < totalPages) {
      const newPage = currentPage + 1;
      setCurrentPage(newPage);
      onPageChange(newPage);
    }
  };

  const changePage = (pageNumber) => {
    setCurrentPage(pageNumber);
    onPageChange(pageNumber);
  };

  const renderDots = () => {
    const dots = [];
    for (let i = 1; i <= totalPages; i++) {
      dots.push(
        <span
          key={i}
          onClick={() => changePage(i)}
          style={{
            cursor: "pointer",
            margin: "0 5px",
            fontSize: 32,
            color: currentPage === i ? "#66CC23" : "lightgray",
          }}
        >
          •
        </span>
      );
    }
    return dots;
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center" /* Center the content horizontally */,
        marginLeft: -60,
        marginTop: 10,
      }}
    >
      <button
        onClick={goToPreviousPage}
        disabled={currentPage === 1}
        style={{
          cursor: currentPage === 1 ? "not-allowed" : "pointer",
          background: "none",
          border: "none",
          fontSize: 25,
          marginBottom: -5,
          marginRight: -5,
        }}
      >
        <Icon name="chevron left" />
      </button>
      <div style={{ display: "flex" }}>{renderDots()}</div>
      <button
        onClick={goToNextPage}
        disabled={currentPage === totalPages}
        style={{
          cursor: currentPage === totalPages ? "not-allowed" : "pointer",
          background: "none",
          border: "none",
          fontSize: 25,
          marginBottom: -5,
        }}
      >
        <Icon name="chevron right" />
      </button>
    </div>
  );
};

export default DotsWithArrowsPagination;
